export default {
  name: "Notice of Posting",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify the applicant's Occupation Type in Field H.b within the Preliminary Section of this application",
        type: "info",
        isVisible: {
          when: "occupationType",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description: `Because you indicated that this application is for a professional athlete, this section is not necessary.`,
        type: "success",
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
    ],
  },
  pageInfo: {
    isVisible: {
      when: "occupationType",
      is: [
        "professional_occupation",
        "non_professional",
        "college_university_teacher",
      ],
      operator: "||",
    },
    text: `<b><u>Note:</u></b> The employer must provide notice of the filing of the <i>Application for Permanent Employment 
    Certification</i> and must be able to document that notice was provided to the bargaining representative, or if there is no 
    bargaining representative, by posting the notice to the employer’s employees at the facilities or location(s) 
    of employment, as indicated in Form ETA-9089 – Appendix B, in accordance of 20 CFR 656.10(d). Mark <b><u>ALL</u></b> boxes that 
    apply in this section, but please note that 1c and 1d should only be selected if 1b is selected, and only one box 
    should be selected if 1a, 1e, or 1f is selected.`,
    coloring: "grey",
  },
  sections: [
    {
      isVisible: {
        when: "occupationType",
        is: [
          "professional_occupation",
          "non_professional",
          "college_university_teacher",
        ],
        operator: "||",
      },
      fields: [
        {
          isGroup: {
            showIndividualFieldError: true,
            fields: [
              {
                machine_name: "hcGroup",
                widget: "text",
                hidden: true,
                disabled: true,
                code: "H.e.1",
                validate: [
                  {
                    subsetOfSetRequired: "hcGroup",
                    message: "Please complete at least one.",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: [
                        "bargainingRep",
                        "noBargainingRepPhysical",
                        "noBargainingRepElectronic",
                        "noBargainingRepInHouse",
                        "noBargainingRepPrivate",
                        "noBargainingRepNoNotice",
                      ],
                    },
                  },
                ],
              },
              {
                machine_name: "bargainingRep",
                widget: "checkbox",
                label: "<b>H.e.1a Bargaining Representative</b>",
                choice:
                  "Notice of this filing has been provided to the bargaining representative for workers in the occupation in which the foreign worker will be employed at least 30 days before, but not more than 180 days before, the date the application was filed.",
                tooltip:
                  "Indicate if notice of this filing was provided to the bargaining representative for workers in the occupation in which the foreign worker will be employed and was provided at least 30 days before, but not more than 180 days before, the date the application was filed, by marking the box.",
                setSchema: [
                  { set: "noBargainingRepPhysical", to: 0 },
                  { set: "noBargainingRepElectronic", to: 0 },
                  { set: "noBargainingRepInHouse", to: 0 },
                  { set: "noBargainingRepPrivate", to: 0 },
                  { set: "noBargainingRepNoNotice", to: 0 },
                ],
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "noBargainingRepPrivate",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepNoNotice",
                      is: 1,
                    },
                  ],
                },
              },
              {
                machine_name: "noBargainingRepPhysical",
                widget: "checkbox",
                label:
                  "<b>H.e.1b No Bargaining Representative - Physical Notice</b>",
                choice:
                  "Notice of this filing has been physically posted to employees for consecutive business days in a conspicuous location at the places of employment at least 30 days before, but not more than 180 days before, the date this application was filed.",
                tooltip:
                  "Indicate if notice of this filing has been physically posted for ten (10) consecutive business days in a conspicuous location at the place of employment at least 30 days before, but not more than 180 days before, the date this application was filed, by marking the box.",
                disabled: true,
                setSchema: [
                  { set: "noBargainingRepElectronic", to: 0 },
                  { set: "noBargainingRepInHouse", to: 0 },
                ],
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "bargainingRep",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepPrivate",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepNoNotice",
                      is: 1,
                    },
                  ],
                },
              },
              {
                machine_name: "noBargainingRepElectronic",
                widget: "checkbox",
                label:
                  "<b>H.e.1c No Bargaining Representative - Electronic Notice</b>",
                choice:
                  "Notice of this filing has been disseminated electronically at least one (1) time, which is the employer’s normal practice of informing current employees of job vacancies at least 30 days before, but not more than 180 days before, the date this application was filed.",
                tooltip:
                  "Indicate if notice of this filing was disseminated electronically at least one (1) time, in a manner in accordance with the employer’s normal practice of informing current employees of job vacancies, at least 30 days before, but not more than 180 days before, the date this application was filed, by marking the box.",
                disabled: true,
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "bargainingRep",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepPhysical",
                      is: [0, null, undefined],
                    },
                    {
                      when: "noBargainingRepPrivate",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepNoNotice",
                      is: 1,
                    },
                  ],
                },
              },
              {
                machine_name: "noBargainingRepInHouse",
                widget: "checkbox",
                label:
                  "<b>H.e.1d No Bargaining Representative - In-House Notice</b>",
                choice:
                  "Notice of this filing has been disseminated using all in-house media, which is the employer’s normal practice of informing current employees of job vacancies at least 30 days before, but not more than 180 days before, the date this application was filed.",
                tooltip:
                  "Indicate if notice of this filing has been disseminated using all in-house media, in a manner in accordance with the employer’s normal practice of informing current employees of job vacancies at least 30 days before, but not more than 180 days before, the date this application was filed, by marking the box.",
                disabled: true,
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "bargainingRep",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepPhysical",
                      is: [0, null, undefined],
                    },
                    {
                      when: "noBargainingRepPrivate",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepNoNotice",
                      is: 1,
                    },
                  ],
                },
              },
              {
                machine_name: "noBargainingRepPrivate",
                widget: "checkbox",
                label:
                  "<b>H.e.1e No Bargaining Representative - Private Household</b>",
                choice:
                  "Notice of this filing has been posted physically and/or disseminated electronically, in accordance with the employer’s normal practice of informing current employees in the private household at least 30 days before, but not more than 180 days before, the date this application was filed.",
                tooltip:
                  "Indicate if notice of this filing has been posted physically and/or disseminated electronically, in accordance with the employer’s normal practice of informing current employees in the private household, at least 30 days before, but not more than 180 days before, the date this application was filed, by marking the box.",
                disabled: true,
                setSchema: [
                  { set: "noBargainingRepPhysical", to: 0 },
                  { set: "noBargainingRepElectronic", to: 0 },
                  { set: "noBargainingRepInHouse", to: 0 },
                  { set: "noBargainingRepNoNotice", to: 0 },
                ],
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "bargainingRep",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepNoNotice",
                      is: 1,
                    },
                  ],
                },
              },
              {
                machine_name: "noBargainingRepNoNotice",
                widget: "checkbox",
                label: "<b>H.e.1f</b>",
                tooltip:
                  "Mark this box if the employer <b><u>DID NOT</u></b> post the notice of filing.",
                choice:
                  "The employer <b><u>DID NOT</u></b> post the notice of filing.",
                disabled: true,
                setSchema: [
                  { set: "noBargainingRepPhysical", to: 0 },
                  { set: "noBargainingRepElectronic", to: 0 },
                  { set: "noBargainingRepInHouse", to: 0 },
                  { set: "noBargainingRepPrivate", to: 0 },
                ],
                disableWhenField: {
                  type: "checkbox",
                  when: [
                    {
                      when: "bargainingRep",
                      is: 1,
                    },
                    {
                      when: "noBargainingRepPrivate",
                      is: 1,
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],
};
